import { render, staticRenderFns } from "./chooseCoupon.vue?vue&type=template&id=c84b921a&"
import script from "./chooseCoupon.vue?vue&type=script&lang=js&"
export * from "./chooseCoupon.vue?vue&type=script&lang=js&"
import style0 from "./chooseCoupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports